import { jsx } from "react/jsx-runtime";
import { Rack } from "./Rack.js";
import { RackWithDVR } from "./RackWithDVR/index.js";
import { debug } from "../../../log.js";
const debugVideoControlRack = debug.extend("video-control-rack");
const VideoControlRack = ({
  adBlock = false,
  isVOD = false,
  showPipButton = true,
  withDvrRack = false,
  onPipRequest,
  onFullScreenRequest
}) => {
  debugVideoControlRack(
    "### DEBUG OMEGA NPM: STEP 1 - VideoControlRack received onPipRequest:",
    !!onPipRequest
  );
  if (withDvrRack) {
    return /* @__PURE__ */jsx(
      RackWithDVR,
      {
        showPipButton,
        isVOD,
        onPipRequest,
        onFullScreenRequest
      }
    );
  }
  return /* @__PURE__ */jsx(
    Rack,
    {
      showPipButton,
      adBlock,
      onPipRequest,
      onFullScreenRequest
    }
  );
};
export {
  VideoControlRack,
  VideoControlRack as default };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/index.js.map